import { bl_mlm_program_cc_endpoint_link_RowClass,} from "../../../dbschema";
import { BaseContainerModel } from "../../base-container.model";


export class MlmProgramCCEndpointLinkContainerModel extends BaseContainerModel {

    bl_mlm_program_cc_endpoint_link : bl_mlm_program_cc_endpoint_link_RowClass = new bl_mlm_program_cc_endpoint_link_RowClass();
}